export const START_TODAY = 'StartToday';
export const START_AT_RETIREMENT = 'StartAtRetirement';
export const END_AT_RETIREMENT = 'EndAtRetirement';
export const END_OF_PLAN = 'EndOfPlan';
